import { render, staticRenderFns } from "./CreateTerm.vue?vue&type=template&id=2d123a7c"
import script from "./CreateTerm.vue?vue&type=script&lang=js"
export * from "./CreateTerm.vue?vue&type=script&lang=js"
import style0 from "./CreateTerm.vue?vue&type=style&index=0&id=2d123a7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports